import { createContext, useContext } from 'react';

interface PageActionsContextValue {
  isInResponsivePageActions: boolean;
}

const PageActionsContext = createContext<PageActionsContextValue | null>(null);

export interface PageActionsContextProviderProps {
  children: React.ReactNode;
}

const DEFAULT_PAGE_ACTIONS_CONTEXT_VALUE: PageActionsContextValue = {
  // Default to true because we only use this context provider when we're using the responsive page actions.
  isInResponsivePageActions: true,
};

/**
 * Context provider that is automatically included by the new `ResponsivePageActions`. This context helps with enabling
 * behavior specific to the new page actions as we slowly migrate to them.
 */
export function PageActionsContextProvider({ children }: PageActionsContextProviderProps) {
  return (
    <PageActionsContext.Provider value={DEFAULT_PAGE_ACTIONS_CONTEXT_VALUE}>{children}</PageActionsContext.Provider>
  );
}

/**
 * Returns true when inside a `ResponsivePageActions` component. Helpful for enabling/disabling behavior specific to
 * the `ResponsivePageActions` as we slowly migrate to them.
 */
export const useIsInResponsivePageActions = (): boolean => {
  const context = useContext(PageActionsContext);

  if (!context) {
    return false;
  }

  return context.isInResponsivePageActions;
};
